import { parseISO, format } from 'date-fns';

type InfoEvaluationPerformanceProps ={
    namePerformance:string,    
    type:string,
    startPeriod:string,    
    endPeriod:string,    
    description:string
  }

const formatDate=(stringDate:string)=>{
  const parsedStartPeriod = parseISO(stringDate);
  const formattedStartPeriod = format(parsedStartPeriod, 'dd/ MM /yyyy');
  return formattedStartPeriod
}

const InfoEvaluationPerformance = ({namePerformance,startPeriod,endPeriod,description,type}:InfoEvaluationPerformanceProps) => {
  return (
   <div className="containerInfoEvalPerformanceQual">
    <div><span className="titleInfoEvalPerformanceQual">{`${namePerformance} (${type}°)`} </span> </div>  
    <div><span className="periodInfoEvalPerformanceQual">{description}</span></div>
    <div><span className="periodInfoEvalPerformanceQual">Período: {`${formatDate(startPeriod)} - ${formatDate(endPeriod)}`}</span></div>         
  </div>
  )
}

export default InfoEvaluationPerformance

